import {
  useOrderedQueryResults as useCoreOrderedQueryResults,
  UseOrderedProps,
} from '@hooks/use-ordered-query-results';

import { useUserOption } from './authentication/hooks';
import { CompanyUserOptions } from './authentication/requests';

export const useOrderedQueryResults = (
  props: Omit<UseOrderedProps<CompanyUserOptions>, 'useUserOptionHook'>,
) =>
  useCoreOrderedQueryResults<CompanyUserOptions>({
    ...props,
    useUserOptionHook: useUserOption,
  });
